<template>
    <div class="image-uploader-component" :class="`image-uploader_${ size } ${ hidden ? 'hidden' : '' }`">
        <a-upload ref="uploader"
        listType="picture-card"
        class="avatar-uploader"
        :showUploadList="false"
        :action="uploadUrl"
        :accept="accept"
        :customRequest="ossUploader"
        @change="imageUploadHandler"
        :beforeUpload="beforeUpload"
        :withCredentials="true"
        name="file"
        :data="data"
        :disabled="disabled"
        :headers="{ Authorization: UserInfoTool.getToken() }"
        >

            <a-spin :spinning="S_img_loading">
                <div class="uploadCover">
                    <img v-if="imageUrl" @load="imageLoadedHandler" @error="imageLoadedErrorHandler" :src="imageUrl">
                    <slot v-else>
                        <a-icon class="topIcon textColor"
                                :type="S_loading ? 'loading' : 'plus'" />
                        <p class="title textColor">上传图片</p>
                        <div class="text textColor">
                            <p v-if="showLimit">{{ typeText }} 格式 不超过 {{ limit }} {{ unit }}</p>
                            <p v-if="specialText">{{specialText}}</p>
                            <!-- <p v-if="specialText">尺寸等于1029px*576px</p> -->
                            <p v-else>尺寸不小于900px*500px</p>
                            <p v-if="description">{{ description }}</p>
                        </div>
                    </slot>
                </div>
            </a-spin>
        </a-upload>
    </div>
</template>

<script type="text/ecmascript-6">

    /**
     * 统一图片上传组件
     * @prop {String} data 附带的载荷
     * @prop {String} value 编辑时传入
     * @prop {String} accept 默认 'image/jpeg,image/png'
     * @prop {String} size 样式大小 默认 normal 可选 normal mini
     * @prop {String} limit 图片限制大小
     * @prop {String} showLimit 显示图片限制文字
     * @prop {String} unit 图片限制大小 单位 默认 MB，可选 KB,MB
     * @prop {String} description 小文字描述
     * @prop {Boolean} hidden 是否隐藏当前组件 UI
     * @prop {Boolean} disabled 是否禁用
     * 
     * @method invokeUpload(uploadedCallback(filePath,file,response)) 手动触发选择图片上传
     *
     * @event uploaded(imagePath) 上传成功事件
     */
    import UserInfoTool from '@/plugins/user-info-tool';
    import moment  from 'moment';
    export default {
        name: 'ImageUploaderComponent',
        zh: '统一图片上传组件',
        props: {
            hidden: Boolean,
            data: {
                type: Object,
                default: () => ({})
            },
            accept: {
                type: String,
                default: 'image/jpeg,image/png,image/gif'
            },
            description: String,
            showLimit: Boolean,
            disabled: Boolean,
            specialText: {
                type: String,
                default: undefined
            },
            limit: {
                type: Number,
                default: 10
            },
            unit: {
                type: String,
                default: 'MB'
            },
            size: {
                type: String,
                default: 'normal'
            },
            value: String,

        },
        data() {
            const domain = process.env.VUE_APP_API_URL;
            const date = new Date()
            return {
                S_loading: false,
                S_img_loading: false,
                uploadUrl: domain + '/admin/attachment/upload/platform/' + moment().format("YYYY-MM-DD"),
                imageUrl: '',
                UserInfoTool,
                domain,
                uploadedCallback: new Function(),
                time: Date.now(),
                key: undefined,
            }
        },
        watch: {
            inputValue(val) {
                this.imageUrl = val;
                // if (val) {
                //     this.S_img_loading = true;
                // }
                this.S_loading = false;
            }
        },
        computed: {
            typeText() {
                return this.accept.replace(/\w+\//g, '').split(',').join('/');
            },
            inputValue() {
                if (this.value) {
                    return this.value;
                }
                return '';
            }
        },
        methods: {
            ossUploader({ onProgress, onSuccess, onError, file }) {
                this.$api.common.getOssKey().then(data => {
                    let time = new Date().getTime();
                    this.key = 'images/' + this.$moment().format('YYYYMMDD') + '/' + time + '_' + "backImage";
                    const formData = new FormData();
                    const body = {
                        key: this.key,
                        OSSAccessKeyId: data.accessKeyId,
                        policy: data.policy,
                        Signature: data.signature,
                        file,
                        success_action_status: '200'
                    };
                    Object.keys(body).forEach(key => formData.append(key, body[key]));
                    return this.$api.common.ossUpload({
                        body: formData
                    }, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: ({ total, uploaded }) => {
                            onProgress({ percent: uploaded / total * 100 });
                        }
                    });
                })
                .then((ossRes) => {
                    onSuccess();
                })
                .catch(err => {
                    onError(err);
                })
            },
            // 手动触发选择图片上传
            invokeUpload(uploadedCallback) {
                this.uploadedCallback = uploadedCallback || new Function();
                const ipt = this.$el.querySelector('input');
                ipt.click();
            },

            // 上传之前验证
            beforeUpload(file) {
                this.$emit('beforeUpload', file);
                this.S_loading = true;

                const typeLimit = this.accept.split(',').some(_type => file.type === _type);
                if (!typeLimit) {
                    this.$message.error('请上传格式正确的图片');
                }
                let sizeLimit;
                if (this.unit === 'MB' || this.unit === 'M') {
                    sizeLimit = file.size / 1024 / 1024 < this.limit;
                }
                else {
                    sizeLimit = file.size / 1024 < this.limit;
                }
                if (!sizeLimit) {
                    this.$message.error(`请使用小于${this.limit}${this.unit}的图片!`);
                }
                let result = sizeLimit && typeLimit;
                if (!result) this.S_loading = false;
                return result;
            },

            // 上传成功
            imageUploadHandler({ file }) {
                if (file.status === 'done') {
                    this.imageUrl = 'https://apailang.oss-cn-hangzhou.aliyuncs.com/' + this.key;
                    this.S_loading = false;
                    this.S_img_loading = true;
                    this.uploadedCallback(this.imageUrl, file.originFileObj, file.response);
                    this.$emit('uploaded', this.imageUrl, file.originFileObj, file.response);
                }
                else if (file.status === 'error') {
                    this.S_loading = false;
                }
            },

            // 图片加载完成
            imageLoadedHandler() {
                this.S_img_loading = false;
                this.$emit('imageUploaded');
            },
            imageLoadedErrorHandler() {
                this.S_img_loading = false;
            }
        },
        mounted() {
            this.imageUrl = this.value
        },
    }
</script>

<style lang="scss" >
    .image-uploader-component {
        &.hidden {
            display: none;
        }
        .ant-upload {
            width: 230px;
            height: 128px;
        }
    }
</style>
